import { listTeam } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type Params = {
  accessToken: string
  accountId: string
}

export type MyOrganization = {
  id: string
  title: string
  uriImage?: string
  organizationNumber: string
  myMemberNumber: number
  migrationId: number | undefined
  paidFunctionEnabled: boolean
  showAdsFlg: boolean
  role?: string
  prefecture?: { id: string; label: string }
  city?: { id: string; label: string }
  category?: { id: string; label: string }
  subCategory?: { id: string; label: string }
}

export const getMyOrganizations = async ({ accessToken, accountId }: Params): Promise<MyOrganization[]> => {
  const result = await execApi(
    () =>
      listTeam(accessToken, {
        accountId: accountId,
        appInfo,
      }),
    (res) => {
      return res.listTeam.items.map((item) => ({
        id: item.team.id,
        title: item.team.name,
        role: item.role,
        organizationNumber: item.team.invitationCode,
        myMemberNumber: item.memberSeq,
        migrationId: item.team.migrationId,
        paidFunctionEnabled: item.team.paidFunctionEnabled ?? true,
        showAdsFlg: item.team.showAdsFlg ?? true,
        prefecture: {
          id: item.team.prefecture.id,
          label: item.team.prefecture.label,
        },
        city: {
          id: item.team.city.id,
          label: item.team.city.label,
        },
        category: {
          id: item.team.category.id,
          label: item.team.category.label,
        },
        subCategory: {
          id: item.team.activity.id,
          label: item.team.activity.label,
        },
      }))
    },
    {
      identifiers: ["getMyOrganizations", "listTeam"],
    }
  )

  return result.isOk ? result.content : []
}
